<template>
  <div>
    <v-data-table
      data-cy="reminders"
      ref="listRemindersTable"
      :page.sync="page"
      :headers="headers.filter((x) => x.showOn.some((y) => y === showOn))"
      :items="
        reminders.filter((x) =>
          stage === 'Courtesy' ? x.smsReminder.length > 0 : true
        )
      "
      item-key="id"
      :search="keyword"
      class="elevation-1 pb-6"
      :loading="loading"
      no-data-text="No data to display"
      :items-per-page="15"
    >
      <template v-slot:top>
        <v-snackbar v-model="processError" :multi-line="true" :color="'error'">
          {{ errorMsg }}
          <v-btn dark text @click="processError = false">Close</v-btn>
        </v-snackbar>
        <v-toolbar flat>
          <v-toolbar-title
            :class="showOn === 'customers' ? 'title-width' : ''"
            >{{ title }}</v-toolbar-title
          >
          <v-divider
            v-if="showOn != 'excluded'"
            class="mx-5 primary"
            inset
            vertical
          ></v-divider>
          <div class="row" v-if="showOn === 'customers'">
            <div class="col-5 col-md-4">
              <div class="row">
                <div class="col-4 pa-0">
                  <v-select
                    data-cy="balanceOptions"
                    v-model="balanceOpt"
                    :disabled="loading"
                    :items="balanceOptions"
                    label="Month"
                    hide-details
                  ></v-select>
                </div>
                <div class="col-4 pa-0">
                  <v-select
                    data-cy="balanceMargin"
                    v-model="balanceMargin"
                    :disabled="loading"
                    :items="balanceMarginOption"
                    hide-details
                  ></v-select>
                </div>
                <div class="col pa-0">
                  <v-text-field
                    v-if="balanceOpt == 'Current'"
                    :disabled="loading"
                    data-cy="balance"
                    v-model="currBalance"
                    label="Balance"
                    hide-details
                    type="number"
                    clearable
                  ></v-text-field>
                  <v-text-field
                    v-if="balanceOpt == 'Month 1'"
                    :disabled="loading"
                    data-cy="balance"
                    v-model="month1Balance"
                    label="Balance"
                    hide-details
                    type="number"
                  ></v-text-field>
                  <v-text-field
                    v-if="balanceOpt == 'Month 2'"
                    :disabled="loading"
                    data-cy="balance"
                    v-model="month2Balance"
                    label="Balance"
                    hide-details
                    type="number"
                  ></v-text-field>
                  <v-text-field
                    v-if="balanceOpt == 'Month 3'"
                    :disabled="loading"
                    data-cy="balance"
                    v-model="month3Balance"
                    label="Balance"
                    hide-details
                    type="number"
                  ></v-text-field>
                </div>
              </div>
            </div>
            <div class="col-3 col-md-2">
              <v-select
                data-cy="selectStage"
                :disabled="loading"
                v-model="stage"
                :items="options"
                label="Stage"
                hide-details
                clearable
              ></v-select>
            </div>
            <div class="col-3 col-md-2">
              <v-select
                data-cy="group"
                :disabled="loading"
                v-model="group"
                label="Group"
                hide-details
                :items="groupOptions"
                item-text="name"
                item-value="name"
                clearable
              ></v-select>
            </div>
            <div class="col-3 col-md-2">
              <v-select
                data-cy="state"
                v-model="state"
                :disabled="loading"
                label="State"
                hide-details
                :items="stateOptions"
                item-text="label"
                item-value="value"
                clearable
              ></v-select>
            </div>
          </div>
          <div v-if="showOn === 'reminders'">
            <v-select
              data-cy="selectStage"
              v-model="stage"
              :items="options"
              :disabled="loading"
              label="Select stage"
              hide-details
              style="width: 150px"
              @change="onSelectStage"
            ></v-select>
          </div>
          <div v-if="showOn != 'excluded'" class="flex-grow-1">
            <v-btn
              data-cy="refresh"
              class="primary float-right"
              :disabled="loading"
              :loading="dialog"
              @click="refreshReminders()"
              >Refresh</v-btn
            >
            <v-btn
              v-if="showOn === 'reminders'"
              data-cy="sendAll"
              class="primary float-right"
              :loading="dialog"
              :disabled="!anySmsEmail || loading"
              @click="
                dialogActive = stage != '' ? !dialogActive : isEmpty();
                getImportMessage();
                message = message;
              "
              >Send All</v-btn
            >
            <!-- <v-btn class="primary float-right" @click="getImportMessage">Test</v-btn> -->
            <v-dialog v-model="dialog" persistent width="300">
              <v-card color="primary" dark>
                <v-card-text class="pt-3 white--text">
                  Please stand by
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-btn
              v-if="showOn === 'reminders'"
              data-cy="import"
              :disabled="loading"
              class="primary mr-3 float-right"
              @click="getAgedReceivables"
              >Import Report</v-btn
            >
            <ImportDialog
              class="mt-5"
              :importDialog="importDialog"
              @close="importDialog = false"
              @import="loadReminders()"
            ></ImportDialog>
          </div>
        </v-toolbar>
      </template>

      <template v-slot:header.sendSMS="{ header }">
        <span class="text-no-wrap d-flex pt-5">{{ header.text }}</span>
        <v-checkbox
          class="mt-0 pb-3 d-flex"
          :disabled="loading"
          color="primary"
          @change="
            allSMS = !allSMS;
            selectAll('sms');
          "
          hide-details
        ></v-checkbox>
      </template>

      <template v-slot:header.sendEmail="{ header }">
        <span class="text-no-wrap d-flex pt-5">{{ header.text }}</span>
        <v-checkbox
          class="mt-0 pb-3 d-flex"
          :disabled="loading"
          color="primary"
          @change="
            allEmail = !allEmail;
            selectAll('email');
          "
          hide-details
        ></v-checkbox>
      </template>

      <template v-slot:header.latePayment="{ header }">
        <span class="text-center justify-center d-flex pt-5">{{
          header.text
        }}</span>
      </template>

      <template v-slot:header.tempNoLatePaymentFeeActive="{ header }">
        <span class="text-center justify-center d-flex pt-3">{{
          header.text
        }}</span>
      </template>

      <template v-slot:header.balance="{ header }">
        <span class="justify-end d-flex pr-4">{{ header.text }}</span>
      </template>
      <template v-slot:header.mthCurr="{ header }">
        <span class="justify-end d-flex pr-4">{{ header.text }}</span>
      </template>
      <template v-slot:header.mth1="{ header }">
        <span class="justify-end d-flex pr-4">{{ header.text }}</span>
      </template>
      <template v-slot:header.mth2="{ header }">
        <span class="justify-end d-flex pr-4">{{ header.text }}</span>
      </template>
      <template v-slot:header.mth3="{ header }">
        <span class="justify-end d-flex pr-4">{{ header.text }}</span>
      </template>

      <template v-slot:header.excludeReason="{ header }">
        <span class="justify-center text-no-wrap">{{ header.text }}</span>
      </template>

      <template v-slot:header.include="{ header }">
        <span class="justify-center text-no-wrap">{{ header.text }}</span>
      </template>

      <template v-slot:item.sendSMS="{ value, item }">
        <div class="d-flex">
          <v-checkbox
            class="mt-0 mb-1 justify-center"
            color="primary"
            v-model="item.sendSMS"
            hide-details
          ></v-checkbox>
          <div data-cy="icons" v-show="item.sendSMS" class="mt-1">
            <v-icon :color="item.icon.color">{{ item.icon.type }}</v-icon>
          </div>
        </div>
      </template>

      <template v-slot:item.sendEmail="{ value, item }">
        <div class="d-flex">
          <v-checkbox
            class="mt-0 mb-1 justify-center"
            color="primary"
            v-model="item.sendEmail"
            hide-details
          ></v-checkbox>
          <div
            data-cy="icons"
            v-if="selected.some((selected) => selected.id === item.id)"
            class="mt-1"
          >
            <v-icon :color="item.icon.color">{{ item.icon.type }}</v-icon>
          </div>
        </div>
      </template>

      <template v-slot:item.latePayment="{ value, item }">
        <v-checkbox
          data-cy="last-payment"
          class="mt-0 mb-1 d-flex justify-center"
          color="primary"
          v-model="item.noLatePaymentFee"
          hide-details
          @change="updateLatePayment(item)"
        ></v-checkbox>
      </template>

      <template v-slot:item.tempNoLatePaymentFeeActive="{ value, item }">
        <v-checkbox
          data-cy="last-payment"
          class="mt-0 mb-1 d-flex justify-center"
          color="primary"
          v-model="item.tempNoLatePaymentFeeActive"
          hide-details
          @change="updateNoLatePaymentFeeTemp(item)"
        ></v-checkbox>
      </template>

      <template v-slot:item.showDetails="{ value, item }">
        <v-btn
          :disabled="loading"
          color="primary"
          :data-cy="`show${item.id}`"
          @click="showDetails(item)"
          >Show</v-btn
        >
      </template>

      <template v-slot:item.balance="{ value, item }">
        <td class="d-flex justify-end border pt-4">{{ value | currency }}</td>
      </template>

      <template v-slot:item.mthCurr="{ value, item }">
        <td class="d-flex justify-end border pt-4">{{ value | currency }}</td>
      </template>

      <template v-slot:item.mth1="{ value, item }">
        <td class="d-flex justify-end border pt-4">{{ value | currency }}</td>
      </template>
      <template v-slot:item.mth2="{ value, item }">
        <td class="d-flex justify-end border pt-4">{{ value | currency }}</td>
      </template>
      <template v-slot:item.mth3="{ value, item }">
        <td class="d-flex justify-end border pt-4">{{ value | currency }}</td>
      </template>

      <template v-slot:item.exclude="{ value, item }">
        <v-btn
          color="primary"
          :disabled="loading"
          :data-cy="`exclude${item.id}`"
          @click="exclude(item)"
          >Exclude</v-btn
        >
      </template>

      <template v-slot:item.success="{ value, item }">
        <td class="d-flex justify-end border pt-4">
          <div v-if="item.success">
            <v-icon color="green">check_circle</v-icon>
          </div>
          <div v-else>
            <v-icon color="red">clear</v-icon>
          </div>
        </td>
      </template>

      <template v-slot:item.reasonForExclusion="{ value, item }">
        <span>{{ item.reasonForExclusion }}</span>
      </template>

      <template v-slot:item.include="{ value, item }">
        <v-btn
          color="primary"
          :disabled="loading"
          :data-cy="`include${item.id}`"
          @click="include(item)"
          >Include</v-btn
        >
      </template>

      <template v-slot:footer>
        <div class="ml-5">
          <AppDialog
            class="mt-5"
            :dialogActive="dialogActive"
            :message="message"
            @cancel="cancel"
            @proceed="proceed()"
          ></AppDialog>
        </div>

        <div>
          <DetailsDialog
            v-if="clickDialog"
            :showOn="showOn"
            :clickDialog="clickDialog"
            ref="financials"
            class="mt-5"
            :clickData="clickData"
            @close="
              clickDialog = false;
              clearFinancials();
            "
            @load="showDetails"
          ></DetailsDialog>
        </div>
      </template>
    </v-data-table>
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      bottom
      middle
      fixed
      dark
      class="text-lg-right"
      color="primary"
      @click="toTop"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AppDialog from "@/components/dialogs/AppDialog";
import DetailsDialog from "@/components/dialogs/DetailsDialog";
import ImportDialog from "@/components/dialogs/ImportDialog";
import { EventBus } from "../../plugins/event-bus.js";

export default {
  name: "ListReminders",
  components: {
    AppDialog,
    ImportDialog,
    DetailsDialog,
  },
  props: {
    showOn: {
      type: String,
    },
    excludeType: {
      type: String,
    },
  },
  data: () => ({
    processError: false,
    errorMsg: "",
    reminders: [],
    page: 0,
    pagination: {},
    selected: [],
    importDialog: false,
    search: "",
    allSMS: false,
    allEmail: false,
    allLatePayment: false,
    dialogActive: false,
    message: "",
    excludeAll: false,
    clickDialog: false,
    clickData: {},
    hover: false,
    noDataLoading: "No Data Found",
    loading: true,
    snackbar: false,
    text: "No data to display.",
    timeout: 5000,
    length: 0,
    disable: false,
    dialog: false,
    icon: "",
    color: "",
    fab: false,
    stage: "",
    headers: [
      { showOn: ["reminders"], text: "SMS", value: "sendSMS", sortable: false },
      {
        showOn: ["reminders"],
        text: "Email",
        value: "sendEmail",
        sortable: false,
      },
      {
        showOn: ["reminders"],
        text: "No Late Payment Fee",
        value: "latePayment",
        sortable: false,
      },
      {
        showOn: ["reminders"],
        text: "Temp No Late Payment Fee",
        value: "tempNoLatePaymentFeeActive",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded", "customers"],
        text: "Show Details",
        value: "showDetails",
        sortable: false,
      },
      {
        showOn: ["reminders"],
        text: "Group",
        value: "wholesaler",
        sortable: false,
      },
      {
        showOn: ["excluded"],
        text: "Wholesaler",
        value: "wholesaler",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded", "customers"],
        text: "Customer No.",
        value: "customerNo",
        sortable: false,
      },
      {
        showOn: ["customers"],
        text: "Customer Name.",
        value: "customerName",
        sortable: false,
      },
      {
        showOn: ["customers"],
        text: "Group",
        value: "wholesaler",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded", "customers"],
        text: "Company",
        value: "company",
        sortable: false,
      },
      {
        showOn: ["customers"],
        text: "Phone",
        value: "phone",
        sortable: false,
      },
      {
        showOn: ["customers"],
        text: "Mobile",
        value: "mobile",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded", "customers"],
        text: "Balance",
        value: "balance",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded", "customers"],
        text: "Current Month",
        value: "mthCurr",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded", "customers"],
        text: "Month 1",
        value: "mth1",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded", "customers"],
        text: "Month 2",
        value: "mth2",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded", "customers"],
        text: "Month 3",
        value: "mth3",
        sortable: false,
      },
      {
        showOn: ["reminders", "excluded"],
        text: "SMS Reminder",
        value: "smsReminder",
        sortable: false,
      },
      {
        showOn: ["reminders"],
        text: "Notification Sent",
        value: "success",
        sortable: false,
      },
      {
        showOn: ["reminders"],
        text: "Exclude",
        value: "exclude",
        sortable: false,
      },
      {
        showOn: ["excluded"],
        text: "Exclude Reason",
        value: "reasonForExclusion",
        sortable: false,
      },
      {
        showOn: ["excluded"],
        text: "Include",
        value: "include",
        sortable: false,
      },
      {
        showOn: ["customers"],
        text: "Stage",
        value: "stage",
        sortable: false,
      },
      {
        showOn: ["customers"],
        text: "State",
        value: "state",
        sortable: false,
      },
    ],
    options: [
      "Courtesy",
      "Reminder 1",
      "Reminder 2",
      "Reminder 3",
      "Restrict Notice",
    ],
    currBalance: undefined,
    month1Balance: undefined,
    month2Balance: undefined,
    month3Balance: undefined,
    group: "",
    state: "",
    stateOptions: [
      {
        label: "Australian Capital Territory",
        value: "ACT",
      },
      {
        label: "New South Wales",
        value: "NSW",
      },
      {
        label: "Northern Territory",
        value: "NT",
      },
      {
        label: "Queensland",
        value: "QLD",
      },
      {
        label: "South Australia",
        value: "SA",
      },
      {
        label: "Tasmania",
        value: "TAS",
      },
      {
        label: "Victoria",
        value: "VIC",
      },
      {
        label: "Western Australia",
        value: "WA",
      },
    ],
    groupOptions: [],
    balanceOpt: "Current",
    balanceOptions: ["Current", "Month 1", "Month 2", "Month 3"],
    balanceMargin: "Greater Than",
    balanceMarginOption: ["Greater Than", "Equal To", "Less Than"],
  }),
  filters: {
    currency: function (value) {
      //Immediately return value if === 0
      if (value === 0) {
        return "$" + value;
      }

      //If value != 0, return with filter
      return !value ? "" : `$${parseFloat(value).toFixed(2)}`;
    },
  },
  methods: {
    currentMonthFilter(val) {
      if (this.currBalance == 0 || this.currBalance == undefined) return true;

      switch (this.balanceMargin) {
        case "Greater Than":
          return val > this.currBalance;
        case "Equal To":
          return val == this.currBalance;
        case "Less Than":
          return val < this.currBalance;
      }
    },
    month1Filter(val) {
      if (this.month1Balance == 0 || this.month1Balance == undefined)
        return true;

      switch (this.balanceMargin) {
        case "Greater Than":
          return val > this.month1Balance;
        case "Equal To":
          return val == this.month1Balance;
        case "Less Than":
          return val < this.month1Balance;
      }
    },
    month2Filter(val) {
      if (this.month2Balance == 0 || this.month2Balance == undefined)
        return true;

      switch (this.balanceMargin) {
        case "Greater Than":
          return val > this.month2Balance;
        case "Equal To":
          return val == this.month2Balance;
        case "Less Than":
          return val < this.month2Balance;
      }
    },
    month3Filter(val) {
      if (this.month3Balance == 0 || this.month3Balance == undefined)
        return true;

      switch (this.balanceMargin) {
        case "Greater Than":
          return val > this.month3Balance;
        case "Equal To":
          return val == this.month3Balance;
        case "Less Than":
          return val < this.month3Balance;
      }
    },
    groupFilter(val) {
      if (!this.group || this.group == undefined) return true;

      return val.toLowerCase().includes(this.group.toLowerCase());
    },
    stageFilter(val) {
      if (!this.stage || this.stage == undefined) return true;

      if (this.stage === "Courtesy") return true;

      return val === this.stage;
    },
    stateFilter(val) {
      if (!this.state || this.state == undefined) return true;

      return val === this.state;
    },
    ...mapActions("reminders", [
      "getExcludedGroups",
      "getWholesalerReminders",
      "getReminders",
      "processReminders",
      "updateExcludeStatus",
      "sendReminders",
      "getFinancials",
      "excludeCustomer",
      "includeCustomer",
      "getExcludedCustomers",
      "updateNoLatePaymentFee",
      "updateTempNoLatePaymentFee",
      "DeleteTempNoLatePaymentFee",
      "getRemindersForStage",
      "getWholesalerRemindersForStage",
      "sendEmailTest",
      "loadExcludedGroups",
      "importAgedReceivables",
    ]),
    ...mapActions("financials", ["fetchFinancials", "clearFinancials"]),
    ...mapMutations("reminders", [
      "updateWholesalerState",
      "updatePayTermState",
    ]),
    toTop() {
      let vm = this;
      vm.page = 1;
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    exclude(item) {
      this.excludeCustomer(item.customerNo)
        .then(() => {
          let id = this.reminders.map((item) => item.id).indexOf(item.id);
          this.reminders.splice(id, 1);
        })
        .catch(() => {
          this.processError = true;
          this.errorMsg =
            "Something went wrong! Unable to exclude customer row.";
        });
    },
    include(item) {
      this.includeCustomer(item.customerNo, 1).then(() => {
        let id = this.reminders.map((item) => item.id).indexOf(item.id);
        this.reminders.splice(id, 1);
      });
    },
    cancel() {
      this.dialogActive = false;
    },
    proceed() {
      let vm = this;
      vm.dialog = true;
      vm.dialogActive = false;

      vm.selected.forEach((z) => {
        let reminder = [];
        reminder.push(z);
        vm.sendReminders(reminder)
          .then((result) => {
            if (result)
              setTimeout(() => {
                result.forEach((x) => {
                  vm.reminders.forEach((y) => {
                    y.sendEmail = false;
                    y.sendSMS = false;
                    if (x.customerNo === y.customerNo) {
                      if (x.success) {
                        y.success = true;
                      } else {
                        y.success = false;
                      }
                    }
                  });
                });
              }, 1000);

            vm.dialog = false;
          })
          .catch((err) => {
            vm.dialog = false;
            vm.processError = true;
            vm.errorMsg = `Something went wrong! ${err}`;
          });
      });
    },
    selectAll(type) {
      this.reminders.forEach((x) => {
        x.sendSMS = false;
        x.sendEmail = false;
      });
      this.reminders
        .filter((x) =>
          this.stage === "Courtesy" ? x.smsReminder.length > 0 : true
        )
        .forEach((element) => {
          switch (type) {
            case "sms":
              element.sendSMS = type === "sms" && this.allSMS;
              break;
            case "email":
              element.sendEmail = type === "email" && this.allEmail;
              break;
            case "latePayment":
              element.latePayment =
                type === "latePayment" && this.allLatePayment;
              break;
            default:
              element.exclude = type === "exclude" && this.excludeAll;
          }
        });
    },
    showDetails(item) {
      this.clickData = item;
      this.clickDialog = !this.clickDialog;
      // this.$refs.financials.initialize(item);
    },
    onSelectStage(val) {
      let stage = 0;
      switch (val) {
        case "Reminder 1":
          stage = 1;
          break;
        case "Reminder 2":
          stage = 2;
          break;
        case "Reminder 3":
          stage = 3;
          break;
        case "Restrict Notice":
          stage = 4;
          break;
        default:
          stage = 0;
          break;
      }
      //if (stage > 0)
      {
        this.$set(this, "noDataLoading", "Loading Data");
        if (!this.isWholesaler) {
          this.getRemindersForStage(stage)
            .then((data) => {
              if (data.length > 0) {
                this.reminders = data;
              } else {
                this.reminders = [];
              }
              this.length = this.reminders.length;
              //this.loading = false;

              if (this.reminders.length == 0) {
                this.snackbar = true;
              }
            })
            .catch((err) => {})
            .finally(() => {
              this.loading = false;
            });
        } else {
          var reminderData = {};
          reminderData.stage = stage;
          reminderData.payTerm = this.payTerm;
          this.getWholesalerRemindersForStage(reminderData)
            .then((data) => {
              if (data.length > 0) {
                this.reminders = data;
              } else {
                this.reminders = [];
              }
              this.length = this.reminders.length;
              //this.loading = false;

              if (this.reminders.length == 0) {
                this.snackbar = true;
              }
            })
            .catch((err) => {})
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    loadReminders() {
      this.loading = true;
      this.$set(this, "noDataLoading", "Loading Data");

      switch (this.excludeType) {
        case "customers":
          this.getExcludedCustomers()
            .then((data) => {
              this.reminders = data;
              this.length = this.reminders.length;
              //this.loading = false;

              if (this.reminders.length == 0) {
                this.snackbar = true;
              }
            })
            .catch((err) => {})
            .finally(() => {
              this.loading = false;
            });
          break;
        case "group":
          this.getExcludedGroups()
            .then((data) => {
              this.reminders = data;
              this.length = this.reminders.length;
              //this.loading = false;
              if (this.reminders.length == 0) {
                this.snackbar = true;
              }
            })
            .catch((err) => {})
            .finally(() => {
              this.loading = false;
            });
          break;
        default:
          this.refreshReminders();
          break;
      }
      // //this.loading = false;
    },
    refreshReminders() {
      if (this.stage !== null && this.stage !== "") {
        this.onSelectStage(this.stage);
      } else if (!this.isWholesaler) {
        this.getReminders({
          showExcluded: this.showExcluded,
          stage: this.stage,
        })
          .then((data) => {
            this.reminders = data;
            this.length = this.reminders.length;
            if (this.reminders.length == 0) {
              this.snackbar = true;
            }
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.getWholesalerReminders({
          showExcluded: this.showExcluded,
          payTerm: this.payTerm,
          stage: this.stage,
        })
          .then((data) => {
            this.reminders = data;
            this.length = this.reminders.length;
            //this.loading = false;
            if (this.reminders.length == 0) {
              this.snackbar = true;
            }
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    isEmpty() {
      this.processError = true;
      this.errorMsg = "Stage is invalid! Select stage to proceed.";
    },
    updateLatePayment(item) {
      this.updateNoLatePaymentFee(item);
    },
    updateNoLatePaymentFeeTemp(item) {
      let vm = this;
      this.updateTempNoLatePaymentFee(item)
        .then(() => {
          vm.reminders.filter(
            (x) => x.customerNo == item.customerNo
          )[0].noLatePaymentFee = item.tempNoLatePaymentFeeActive;
        })
        .catch(() => {});
    },
    getImportMessage() {
      let vm = this;

      vm.selected = vm.reminders.filter((x) => x.sendSMS || x.sendEmail);
      vm.selected.forEach(function (element) {
        element.stage = vm.stage;
      });
      vm.message = `Are you sure you want to send ${vm.selected.length} reminder/s?`;
    },
    loadGroup() {
      this.loadExcludedGroups().then((data) => {
        this.groupOptions = data.filter(
          (x) => x.isWholesaler == 0 || x.isWholesaler == null
        );
      });
    },
    getAgedReceivables() {
      const vm = this;
      this.loading = true;
      vm.importAgedReceivables()
        .then((data) => {
          this.reminders = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters("search", ["keyword"]),
    ...mapGetters("reminders", ["isWholesaler", "payTerm"]),
    ...mapGetters("financials", ["contactLogs", "payments", "credits"]),
    showExcluded() {
      return this.showOn === "excluded";
    },
    anySmsEmail() {
      let vm = this;
      if (vm.stage && this.reminders.some((x) => x.sendSMS || x.sendEmail))
        return true;
      else return false;
    },
    title() {
      let label;
      if (this.showOn === "excluded") {
        label = "Excluded Customers";
      } else if (this.showOn === "customers") {
        label = "Customers";
      } else {
        label = "Reminders";
      }
      return label;
    },
  },
  watch: {
    loading(val) {
      EventBus.$emit("isLoading", val);
      return val;
    },
  },
  created() {
    if (this.showOn === "customers") this.loadGroup();
    setTimeout(() => {
      EventBus.$on("typeSelected", (msg) => {
        if (msg === "Wholesaler-14 Days") {
          this.updateWholesalerState(true);
          this.updatePayTermState(14);
        } else if (msg === "Wholesaler-30 Days") {
          this.updateWholesalerState(true);
          this.updatePayTermState(30);
        } else {
          this.updateWholesalerState(false);
        }
        this.loadReminders();
      });
      this.loadReminders();
    }, 100);
  },
  mounted() {
    if (this.showOn == "customers") {
      this.headers.forEach((x) => {
        switch (x.text) {
          case "Current Month":
            x.filterable = true;
            x.filter = this.currentMonthFilter;
            break;

          case "Month 1":
            x.filterable = true;
            x.filter = this.month1Filter;
            break;

          case "Month 2":
            x.filterable = true;
            x.filter = this.month2Filter;
            break;

          case "Month 3":
            x.filterable = true;
            x.filter = this.month3Filter;
            break;

          case "Group":
            x.filterable = true;
            x.filter = this.groupFilter;
            break;

          case "Stage":
            x.filterable = true;
            x.filter = this.stageFilter;
            break;

          case "State":
            x.filterable = true;
            x.filter = this.stateFilter;
            break;
        }
      });
    }
  },
  beforeDestroy() {
    EventBus.$off("typeSelected");
  },
};
</script>

<style lang="scss">
thead tr {
  background-color: rgba(5, 0, 8, 0.05);
}

.border {
  border-bottom: 0 !important;
}

.title-width {
  width: 110px;
}
</style>
